import { Link } from "react-router-dom";

export function Eyebrow({ text, en }: { text: string; en?: string }) {
  return (
    <span className="inline-flex items-center gap-2 text-xs font-medium tracking-[0.2em] text-primary-400 uppercase">
      <span className="h-px w-6 bg-primary-500/70" />
      {text}
      {en && <span className="font-display text-primary-600 normal-case tracking-widest">· {en}</span>}
    </span>
  );
}

export function SectionHeading({
  eyebrow,
  title,
  desc,
  linkTo,
  linkText,
}: {
  eyebrow?: string;
  title: string;
  desc?: string;
  linkTo?: string;
  linkText?: string;
}) {
  return (
    <div className="mb-8 flex flex-col gap-5 md:mb-10 md:flex-row md:items-end md:justify-between">
      <div>
        {eyebrow && <Eyebrow text={eyebrow} />}
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">{title}</h2>
        {desc && <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">{desc}</p>}
      </div>
      {linkTo && linkText && (
        <Link
          to={linkTo}
          className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap text-sm font-medium text-primary-300 transition hover:text-primary-200"
        >
          {linkText}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}

export function BackTop() {
  return (
    <button
      type="button"
      aria-label="返回顶部"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full border border-background-300 bg-background-100/90 text-primary-300 backdrop-blur transition hover:bg-primary-500 hover:text-foreground-100"
    >
      <i className="ri-arrow-up-line" />
    </button>
  );
}